import axiosInstance from '@/plugins/axios'
import sessionService from './session.service'

class AuthService {
  constructor() {
    this.token = sessionService.getToken()
    this.user = sessionService.getUser()
  }

  async login(username, password, remember = false) {
    const response = await axiosInstance.post('/api/auth/login', { username, password })
    if (!response.data?.access_token) {
      throw new Error('O servidor não retornou uma sessão válida.')
    }
    const { access_token, token_type, expires_in, ...user } = response.data
    const authToken = `${token_type || 'Bearer'} ${access_token}`
    this.token = authToken
    this.user = user
    sessionService.save(authToken, user, remember)
    axiosInstance.defaults.headers.common.Authorization = authToken
    return user
  }

  async register(email, name, password, organizationName) {
    const response = await axiosInstance.post('/api/auth/register', {
      email, name, password, organizationName
    })
    return response.data
  }

  logout() {
    sessionService.clear()
    this.token = null
    this.user = null
    delete axiosInstance.defaults.headers.common.Authorization
  }

  isAuthenticated() {
    if (!this.token) this.token = sessionService.getToken()
    return Boolean(this.token)
  }

  async getCurrentUser() {
    if (!this.isAuthenticated()) return null
    try {
      const response = await axiosInstance.get('/api/auth/me')
      this.user = response.data
      sessionService.save(null, response.data, sessionService.isPersistent())
      return response.data
    } catch (error) {
      if (error.response?.status === 401) this.logout()
      return null
    }
  }

  isAdmin() {
    const user = this.getUser()
    return Boolean(user?.is_admin)
  }

  getToken() {
    if (!this.token) this.token = sessionService.getToken()
    return this.token
  }

  getUser() {
    if (!this.user) this.user = sessionService.getUser()
    return this.user
  }
}

export default new AuthService()
